import React, { FC } from "react";
import classes from "./style/Individuals.module.css";
import { IndividualCard } from "./IndividualCard/IndividualCard";
import { useAppSelector } from "../../../../../store/reduxHooks";
import { SELECT_APPLICATIONS_DATA_TO_BANK_MEMBER_FL } from "../../../../../store/selectors/applicationDataToBankSelector";

export const Individuals: FC = () => {
  const data = useAppSelector(SELECT_APPLICATIONS_DATA_TO_BANK_MEMBER_FL);

  return (
    <div className={classes.individualsWrapper}>
      {data?.map((individual) => {
        return (
          <IndividualCard key={individual.id} individual={{ ...individual }} />
        );
      })}
    </div>
  );
};
